var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass:
        "navbar default-layout-navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "text-center navbar-brand-wrapper d-flex align-items-center justify-content-center pt-0"
        },
        [
          _c(
            "router-link",
            {
              staticClass: "navbar-brand brand-logo",
              attrs: { to: { name: "home" } }
            },
            [
              _c("img", {
                attrs: { alt: "logo", src: "/media/aform-logo-black.png" }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "navbar-brand brand-logo-mini",
              attrs: { to: { name: "home" } }
            },
            [
              _c("img", {
                attrs: { alt: "logo", src: "/media/aform-logo-black-mini.png" }
              })
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "navbar-menu-wrapper d-flex align-items-stretch" },
        [
          _c(
            "ul",
            { staticClass: "navbar-nav navbar-nav-right" },
            [
              _c(
                "li",
                { staticClass: "nav-item nav-logout d-none d-lg-block" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "account.info" })
                        }
                      }
                    },
                    [_c("i", { staticClass: "mdi mdi-account" })]
                  )
                ]
              ),
              _vm._v(" "),
              _c("dashboard-notification-menu"),
              _vm._v(" "),
              _c("li", { staticClass: "nav-item nav-logout  d-lg-block" }, [
                _c(
                  "a",
                  {
                    staticClass: "nav-link cursor-pointer",
                    on: { click: _vm.logout }
                  },
                  [_c("i", { staticClass: "mdi mdi-power" })]
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass:
                "navbar-toggler navbar-toggler-right d-lg-none align-self-center",
              attrs: { "data-toggle": "offcanvas", type: "button" },
              on: { click: _vm.toggleSidebarOffcanvas }
            },
            [_c("span", { staticClass: "mdi mdi-menu" })]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }